// ── App configuration ──

// Server URL used by the NATIVE Android/iOS app (Capacitor).
// The native app bundles the web assets locally, so window.location.origin
// would point at the app itself — it must be told where the real server lives.
// Cloud Run service "game-portal" (project game-portal-prod, europe-west1)
export const NATIVE_SERVER_URL = 'https://game-portal-sopendfhva-ew.a.run.app';
